export default __webpack_public_path__ + "static/media/Bindings of Ardent Fire.8f671ade.jpg";